import React from 'react';
import PropTypes from 'prop-types';
import { withField } from 'react-form';
import Autosuggest from 'react-autosuggest';
import LoadingIndicator from '../../components/LoadingIndicator';

const theme = {
    container: 'autosuggest__wrapper',
    containerOpen: 'autosuggest__wrapper--open',
    input: 'text-input text-input--editable',
    inputOpen: '',
    inputFocused: '',
    suggestionsContainer: 'autosuggest__container',
    suggestionsContainerOpen: 'autosuggest__container--open',
    suggestionsList: 'autosuggest__suggestions-list',
    suggestion: 'autosuggest__suggestion',
    suggestionFirst: 'autosuggest__suggestion--first',
    suggestionHighlighted: 'autosuggest__suggestion--highlighted',
    sectionContainer: 'autosuggest__section-container',
    sectionContainerFirst: 'autosuggest__section-container--first',
    sectionTitle: 'autosuggest__section-title',
};

class SuggestField extends React.Component {
    static propTypes = {
        label: PropTypes.string,
        helpLayer: PropTypes.element,
        required: PropTypes.bool,
        onSuggestionsFetchRequested: PropTypes.func.isRequired,
        onSuggestionsClearRequested: PropTypes.func.isRequired,
        suggestions: PropTypes.arrayOf(PropTypes.object).isRequired,
        multiSection: PropTypes.bool,
        getSuggestionValue: PropTypes.func,
        getSectionSuggestions: PropTypes.func,
        renderSuggestion: PropTypes.func,
        renderSectionTitle: PropTypes.func,
        fieldApi: PropTypes.shape({
            fieldName: PropTypes.string.isRequired,
            setValue: PropTypes.func.isRequired,
            value: PropTypes.object,
            setTouched: PropTypes.func.isRequired,
        }).isRequired,
        onChange: PropTypes.func,
        highlightFirstSuggestion: PropTypes.bool,
        isLoading: PropTypes.bool,
        allowCustomValue: PropTypes.bool,
        placeholder: PropTypes.string,
    };

    static defaultProps = {
        label: null,
        helpLayer: null,
        required: false,
        multiSection: false,
        onChange: null,
        highlightFirstSuggestion: false,
        allowCustomValue: false,
        getSuggestionValue: suggestion => (suggestion ? suggestion.label : ''),
        getSectionSuggestions: section => section.entries,
        renderSuggestion: suggestion => suggestion.label,
        renderSectionTitle: section => <strong>{section.title}</strong>,
        isLoading: false,
        placeholder: null,
    };

    constructor(props) {
        super(props);
        this.state = {
            inputValue: '',
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.fieldApi.value !== this.props.fieldApi.value) {
            this.setState({
                inputValue: nextProps.fieldApi.value
                    ? this.props.getSuggestionValue(nextProps.fieldApi.value)
                    : '',
            });
        }
    }

    onChange = (event, { newValue }) => {
        this.setState({
            inputValue: newValue,
        });
        if (this.props.allowCustomValue) {
            this.props.onChange(newValue);
        }
    };

    onBlur = (event, { highlightedSuggestion }) => {
        const {
            fieldApi: {
                setValue,
                value: fieldValue,
                setTouched,
            },
            getSuggestionValue,
            onChange,
            allowCustomValue,
        } = this.props;

        setTouched();

        if (highlightedSuggestion) {
            setValue(highlightedSuggestion);

            this.setState({
                inputValue: highlightedSuggestion.label,
            });

            if (onChange) {
                onChange(highlightedSuggestion.value);
            }
        } else if (this.state.inputValue !== getSuggestionValue(fieldValue)) {
            if (!allowCustomValue) {
                this.setState({
                    inputValue: '',
                });

                if (fieldValue !== null) {
                    setValue(null);

                    if (onChange) {
                        onChange(null);
                    }
                }
            } else {
                setValue({
                    label: this.state.inputValue,
                    value: this.state.inputValue,
                });

                if (onChange) {
                    onChange(this.state.inputValue);
                }
            }
        }
    };

    onSuggestionSelected = (event, selection) => {
        const {
            fieldApi: { setValue },
        } = this.props;

        setValue(selection.suggestion);

        if (this.props.onChange) {
            this.props.onChange(selection.suggestion.value);
        }
    };

    render() {
        const {
            fieldApi,
            helpLayer,
            label,
            required,
            onSuggestionsFetchRequested,
            onSuggestionsClearRequested,
            suggestions,
            multiSection,
            getSuggestionValue,
            getSectionSuggestions,
            renderSuggestion,
            renderSectionTitle,
            highlightFirstSuggestion,
            isLoading,
        } = this.props;

        const inputProps = {
            id: fieldApi.fieldName,
            value: this.state.inputValue,
            onChange: this.onChange,
            onBlur: this.onBlur,
            placeholder: this.props.placeholder,
        };

        return (
            <div className="formrow">
                <label className="formrow__label" htmlFor={fieldApi.fieldName}>
                    {required ? `${label}*` : label}
                </label>
                <div className="formrow__text-input formrow__text-input--editable">
                    {isLoading
                        ? <LoadingIndicator />
                        : <Autosuggest
                            suggestions={suggestions}
                            multiSection={multiSection}
                            onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                            onSuggestionsClearRequested={onSuggestionsClearRequested}
                            getSuggestionValue={getSuggestionValue}
                            getSectionSuggestions={getSectionSuggestions}
                            renderSuggestion={renderSuggestion}
                            renderSectionTitle={renderSectionTitle}
                            onSuggestionSelected={this.onSuggestionSelected}
                            highlightFirstSuggestion={highlightFirstSuggestion}
                            inputProps={inputProps}
                            theme={theme}
                        />
                    }
                    {helpLayer}
                </div>
            </div>
        );
    }
}

export default withField(SuggestField);



// WEBPACK FOOTER //
// ./src/frontend/components/Fields/SuggestField.jsx